// firebase.js
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCnk6eKfZ4Y3lt3reYm8auQfVwn20zYm2M",
  authDomain: "cynexsol.firebaseapp.com",
  projectId: "cynexsol",
  storageBucket: "cynexsol.firebasestorage.app",
  messagingSenderId: "283760148204",
  appId: "1:283760148204:web:8bf7d05fed5752c3e9efc9",
  measurementId: "G-C95QCVCENH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };
